import { useEffect } from 'react';
import { Box, Divider, Typography, colorsPalette } from '@lingoda/ui';
import { useToggleState } from '@lingoda/hooks';
import { MobileConfirmDialog } from '../../../components';
import type { PackageLayoutProps } from '../types';
import type { PackageActionProps } from '../../../types';
import type { PropsWithChildren } from 'react';

const MobileListLayout = ({
    children,
    selectedPackage,
    onCheckout,
    onPackageDeselect,
    isUserSelection,
    isTrialAvailable,
    footerMessage,
}: PropsWithChildren<PackageLayoutProps & PackageActionProps>) => {
    const [isOpen, openDialog, closeDialog] = useToggleState(false);

    const handleClose = () => {
        if (onPackageDeselect) {
            onPackageDeselect();
        }
        closeDialog();
    };

    useEffect(() => {
        if (isUserSelection && selectedPackage && !selectedPackage.isCurrent) {
            openDialog();
        }
    }, [isUserSelection, selectedPackage, openDialog]);

    return (
        <>
            {selectedPackage && (
                <MobileConfirmDialog
                    isOpen={isOpen}
                    isTrialAvailable={isTrialAvailable}
                    pkg={selectedPackage}
                    onCheckout={onCheckout}
                    onClose={handleClose}
                />
            )}
            <Box mt={1} mb={4}>
                <Divider />
            </Box>
            {children}
            {footerMessage && (
                <Typography variant="body1" htmlColor={colorsPalette.blackAlpha[60]}>
                    {footerMessage}
                </Typography>
            )}
        </>
    );
};

export default MobileListLayout;
